import { withBasketSubmissionEvents } from "~/hec/basket/basket-submission-events";

import { buildBasketClientActionFailure } from "./basket-client-failure";
import { containedClientAction } from "./contained-client";

/**
 * The basket route's `clientAction` (exported from `routes/resources/basket.tsx`
 * as `clientAction`; lives here so it can be tested without that module).
 *
 * Two layers:
 *  - COM-63 / SFCC-11876 containment: a network-level failure resolves to the
 *    validation-error envelope from `buildBasketClientActionFailure` instead of
 *    bubbling to the root error boundary.
 *  - COM-830: every RESOLVED submission (success, handled failure, or contained
 *    failure) is published to `basket-submission-events`, which is what the
 *    added-to-cart modal, its failure toasts, the Cart Update / GA4 tracker and
 *    Quick View's close-on-add observe. They can no longer read other
 *    components' fetchers through `useFetchers()`: without the post-action
 *    loader revalidation COM-830 removed, the fetcher settles to idle and leaves
 *    that list before any render sees its data.
 */
export const basketClientAction = withBasketSubmissionEvents(
  containedClientAction("basket.clientAction", buildBasketClientActionFailure),
);
